<template>
  <UPageSection
    v-if="items.length"
    :dir="dir"
    :title="title"
    :ui="{
      title: 'text-2xl font-bold sm:text-3xl text-center',
      container: 'py-10 sm:py-14',
    }"
  >
    <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <figure
        v-for="(item, index) in items"
        :key="index"
        class="group overflow-hidden rounded-xl border border-default/50 bg-elevated/40 shadow-sm"
      >
        <div class="aspect-4/3 overflow-hidden bg-muted/30">
          <img
            v-if="item.image"
            :src="item.image"
            :alt="item.caption || 'Gallery image'"
            class="h-full w-full object-cover transition duration-300 group-hover:scale-105"
          >
          <div
            v-else
            class="flex h-full w-full items-center justify-center text-muted"
          >
            <UIcon
              name="i-lucide-image"
              class="size-12"
            />
          </div>
        </div>
        <figcaption
          v-if="item.caption"
          class="px-3 py-2 text-center text-sm text-muted"
        >
          {{ item.caption }}
        </figcaption>
      </figure>
    </div>
  </UPageSection>
</template>

<script setup lang="ts">
export type GalleryItem = {
  image?: string
  caption?: string
}

withDefaults(
  defineProps<{
    title?: string
    items?: GalleryItem[]
  }>(),
  {
    items: () => [],
  },
)

const dir = useDir()
</script>
